"use strict";

import { create, useStore } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export const themeToggle = create()(
  persist(
    (set) => ({
      mode: "light",
      toggleMode: (mode) => set({ mode: mode === "light" ? "dark" : "light" }),
    }),
    {
      name: "theme-mode",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useThemeStore = () => useStore(themeToggle);
